let cachedWindowScrollbarWidth: number | null = null;

export function getWindowScrollbarWidth(): number {
  if (cachedWindowScrollbarWidth !== null) return cachedWindowScrollbarWidth;
  if (typeof document === 'undefined') return 0;

  const probe = document.createElement('div');
  probe.style.cssText = 'width:100px;height:100px;overflow:scroll;position:absolute;top:-9999px';
  document.body.appendChild(probe);
  cachedWindowScrollbarWidth = probe.offsetWidth - probe.clientWidth;
  document.body.removeChild(probe);
  return cachedWindowScrollbarWidth;
}

export function measureScrollbarWidth(el: HTMLTextAreaElement, hasScroll: boolean): number {
  if (!hasScroll) return 0;

  const measured = el.offsetWidth - el.clientWidth;
  if (measured > 0) return measured;

  // Fallback when textarea measurement is 0 but content still overflows.
  return getWindowScrollbarWidth();
}
